import $ from 'jquery'

const $webinarRecordingButton = $('.js-webinar-button')

const $webinarCover = $('.js-webinar-cover')
const $webinarSource = $('.js-webinar-source')

let $webinarLoader = ''
let $wrapper = ''

if (
  $webinarRecordingButton &&
  $webinarRecordingButton.length &&
  $webinarCover &&
  $webinarSource
) {
  $($webinarRecordingButton).on('click', function(e) {
    e.preventDefault()

    $webinarLoader = $('.js-webinar-loader')
    $wrapper = $(this)

    $webinarLoader.addClass('active')
    $wrapper.addClass('active')

    getWebinar()
  })
}

const getWebinar = function() {
  if (!$wrapper) {
    return
  }

  let doingAjax = false

  if (!doingAjax) {
    jQuery
      .ajax({
        url: securelist2020Data.ajaxUrl,
        data: {
          action: 'securelist_webinar_recording',
          postID: $wrapper.attr('data-post-id')
        },
        dataType: 'json',
        method: 'GET',
        beforeSend: function() {
          doingAjax = true
        }
      })
      .done(function(response) {
        if (response.success) {
          $webinarCover.addClass('u-hidden')
          $webinarSource.find('.c-video-wrapper').html(response.success)
          $webinarSource.removeClass('u-hidden')
        }
        doingAjax = false
      })
      .fail(function(jqXHR, textStatus) {
        console.log('error', textStatus)

        if ($webinarLoader) {
          $webinarLoader.removeClass('active')
        }
        $wrapper.removeClass('active')
        doingAjax = false
      })
  }
}

const $viewWebinarButton = $('.js-view-webinar')

if ($viewWebinarButton && $viewWebinarButton.length) {
  $viewWebinarButton.on('click', function() {
    $('html, body').animate({ scrollTop: 0 })

    const $webinarButton = $('.js-webinar-button, .js-gotowebinar-button')

    if ($webinarButton && $webinarButton.length) {
      $webinarButton.trigger('click')
      $(this).remove()
    }
  })
}
